import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Đánh rơi đồ đạc, vấn nạn trộm cắp, khó khăn trong việc tìm kiếm đồ đạc, thiết bị và lãng phí nguồn lực là những vấn đề thường gặp tại sân bay. Để giải quyết những vấn đề này, RTLS (Real-Time Location System - Hệ thống Định vị thời gian thực) có thể mang đến các giải pháp hiệu quả.',
  keywords: 'RTLS, Sân bay, San bay, Hàng không, Hang khong, Quản lý tài sản, Quản lý tài sản, Quan ly tai san, An toàn, An toan, An ninh',
  ogSite: 'Ứng dụng RTLS tại sân bay',
  title: 'Ứng dụng RTLS tại sân bay',
  ogUrl: 'https://orbro.io/vi/blog/airport',
  ogImg:
    'https://lh3.googleusercontent.com/fife/APg5EOZesBoVKMwIFFry24uoX1306-E2-KIndjXjngk3HQJAqvdeMd-lpFrtUa5bQkacaOFn73rL9aZpISCh6BfSvBY8Rj6pgLzP098EmKNW5WO0k0RSNeqTxeIIE_LiFLF3sUcJc7VhuL6arfAuAQ4APzhaT4aTqEMd8WiAzJwEEVEK3UEevHgYg7ZmwsN-ImqYMFbr01G9VkLQVPdClEaxND6eKem2wvryX-MyUhMvVWmXvao5e8JdFoNh7pmf0ED7MFgYJTg8fxDAxUsbI2jFKwsQCXpbmLsVjR7VcwSNln_gq6BqHDdpB_gte6scXAcPWT5vxnkbmDs22PEDiPDoNcyewtDBBFdtglgRga94O9jfNboErHhvfBncigoMjDxtW7TYVYAps24D2VMURGxOoAx8EquJAIaYIcLlBk2zaSrqdtCeCJGD8Il7sLifXjYw4s7qUr9XFF35LROheqZAC_0kOQ5mI85j5IkNvcvUuT0Wpg9K9Tg1uovCttIBSCD5hfEs1i5gQOxwB7fK0t9kkppR_tDz4HPjIo3i-QfSV3VtiERhnb0gIWUVAFX5jrN8rwX4iTKGpNR55yhogdwRDaSLkHePzB-Xnsn0SwSjXlonVCX02p4Zn02NM8FsMa8fNMfP7Rp4-NIciOdAehNLDjZzwFH6hXgArjIg7_CtUHBeiV5gQ9GX7PqRU4TtZXbljhqePIobwwEd_XHrXRNxAyMxnCU45iqtZUwO_dZyKmhfAZ7XDrUUK0gMaNhguKiZEIm3ZeBZN_082FE9ifEja5-LCI4-QC60gzDs8bYmOrqsotPyR47V6zTrFzRiKDRfwmiLCdbRdQsy3iLV5ph0yhVab492zrx1LaPY39eCtfQzTyDRXrgrwxrAnp54XYMJYZ23TEVgan4Sg7MwiQiYw_Y9z2c1WwAt-TE7rpWOR5Gn2um6jOBrrfo_09UF9nfV4o02ZGF4NWQ99ZIRwBmOg6KODX6mQNtxOjU60pRIpQj0BUCj5JCE5P99E2FRUfxKE89tWwftzf0WpV4XuY3XCnSVpT1DW8OAdsfQyv5GyiSm2ikSlRAq8s0nJAoPv5gcqTR5rwl-QI7YOwucwvhQgM0N3jhPjqcfCsZ0tEP4V-IVLpT1k5_LGmhBueHvi8jZinIgZ0YWZov9jEWK4ysorc637zHhZpy_infWTuHbzXNlLpxoWRsQCbsvGYNKsAVJIi91R85rK5tRbEiMFXA6l67UP2CxWsZHXN_IofYYJmQrT7t6IreFaZrouew2I-5bE-grBY53BCNZ_uk2rE8BPkifZU4ldeMi-0qDyy93SH-XeiDqOWadwsB8yHsrx-6_2UNxAeQzzFEwJtNv0tB4WWtyXgGyX94icliihgFcgXBYPX-t4tGwNJd776YIxod1tvww4WR2a-m5idyeoKDjuWUQrMWHd6JuMKFGGxnIjzUKIQMTx6q2vzwdG62nR80hG1B0_osyET4FeVfNTRdVzDRNcEtrlSSbgcQfMg0Q9LKROQcN6smgad6gObnA6mQB3Ghvo_9zXSkfAufJdY9Kg4g7Px31v1Z2fV3IhA9rzOE5Qg=w2059-h1216',

  ogType: 'website',
  date: '2023-05-10',
  tag1: '#RTLS',
  tag2: '#Sanbay',
  tag3: '#Hangkhong',
  tag4: '#Quanlytaisan #Antoan #Anninh',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Đánh rơi đồ đạc, vấn nạn trộm cắp, khó khăn trong việc tìm kiếm đồ đạc, thiết bị và lãng phí nguồn lực là những vấn đề thường gặp tại sân bay. Để giải quyết những vấn đề này, RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) có thể mang đến các giải pháp hiệu quả.',
      dot: '',
    },
    {
      head: 'RTLS là gì?',
      subHead: '',
      desc: 'RTLS (Real-Time Location System) là hệ thống theo dõi vị trí thời gian thực, cho phép theo dõi vật thể, con người, v.v., cũng như thu thập và xử lý thông tin vị trí theo thời gian thực để ứng dụng vào thực tế. Nhờ đó, hệ thống này giúp nắm bắt, kiểm soát và quản lý sự di chuyển của nhiều đối tượng trong sân bay như hành khách, hàng hóa, thiết bị hàng không. Chính vì vậy, trong vài năm qua, nhiều sân bay đã triển khai các hệ thống theo dõi tài sản.\nThực tế, theo một nghiên cứu thị trường, giá trị của thị trường theo dõi tài sản tại sân bay vào năm 2019 là 350 triệu đô la Mỹ và được dự đoán sẽ đạt 900 triệu đô la Mỹ vào năm 2027.\nSau đây là các ứng dụng giúp giải quyết các vấn đề của hệ thống RTLS.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Bảo trì và quản lý tài sản',
      desc: 'Trước đây, nhân viên sân bay phải trực tiếp kiểm tra bằng mắt thường và ghi chép trên giấy tờ để theo dõi tài sản. Ngay cả khi ghi lại thông tin này trên máy tính bảng (tablet), công việc do con người thực hiện luôn tiềm ẩn sai sót. RTLS giúp giải quyết vấn đề này. Đồng thời, hệ thống có thể phát hiện các trường hợp trộm cắp và phá hoại tài sản, cũng như giúp quản lý công tác bảo trì, sửa chữa một cách dễ dàng. Không chỉ tài sản của sân bay mà cả hành lý của hành khách cũng được kiểm soát thuận tiện hơn. RTLS giúp nhanh chóng xác định các vật dụng bị mất hoặc bị đánh cắp, từ đó giảm thiểu sự lãng phí về nguồn nhân lực và vật lực so với trước đây.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường an toàn và an ninh',
      desc: 'Sân bay là cơ sở đòi hỏi những quy định rất nghiêm ngặt về an toàn và an ninh. Việc giám sát hàng ngàn, hàng vạn người, phương tiện và hành lý qua lại sân bay mỗi ngày không hề dễ dàng, đặc biệt nếu thực hiện hoàn toàn thủ công bằng con người.\nRTLS cho phép chỉ định, theo dõi và kiểm soát các khu vực hạn chế dân sự, qua đó giúp ngăn chặn trước các sự cố và hành vi khủng bố. Nếu hành lý bị đặt ở những vị trí không được phép, người quản lý có thể ngay lập tức ứng phó. Ngoài ra, nếu tích hợp việc quản lý các thiết bị khẩn cấp vào hệ thống quản lý tài sản đã đề cập, trong trường hợp xảy ra sự cố, việc theo dõi các thiết bị an toàn như bình chữa cháy và máy khử rung tim sẽ góp phần đảm bảo an toàn tốt hơn tại sân bay trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Trải nghiệm khách hàng tốt hơn',
      desc: 'Người quản lý có thể nắm bắt được luồng di chuyển của hành khách bên trong sân bay để duy trì hoạt động thông suốt hơn. Hệ thống giúp xác định các khung giờ cao điểm, các cổng ra vào và cửa lên máy bay cụ thể có mật độ đông để hướng dẫn và điều tiết luồng người. Nhờ đó, mỗi hành khách đến sân bay có thể giảm thiểu thời gian lãng phí và thực hiện quy trình lên máy bay một cách thuận lợi.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giảm thiểu chi phí',
      desc: 'Việc kiểm soát và quản lý toàn bộ một sân bay lớn không hề đơn giản. Tuy nhiên, công nghệ RTLS cho phép theo dõi đồng thời các thông tin sân bay mà trước đây cần nhiều người thu thập (và đôi khi còn kèm theo sai sót). Kết quả là có thể giảm chi phí vận hành so với trước đây, đồng thời nâng cao chất lượng dịch vụ.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
